import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

/**
 * One-click "copy to clipboard" button — designed for the admin catalog
 * where managers grab a product/collection link to paste into WhatsApp.
 *
 * Shows a green ✓ tick for 1.5s after successful copy so the manager knows
 * it worked (mobile browsers don't always fire a native toast).
 *
 * Falls back gracefully on old browsers via `document.execCommand("copy")`
 * — some Safari WebViews still ship without navigator.clipboard.
 */
export default function CopyLinkButton({
  url, label = "Копировать", copiedLabel = "Скопировано",
  compact = false, testid,
}) {
  const [copied, setCopied] = useState(false);

  const doCopy = async (e) => {
    e?.stopPropagation?.();
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url; document.body.appendChild(ta);
        ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      alert("Не удалось скопировать. Скопируйте вручную:\n\n" + url);
    }
  };

  return (
    <button
      data-testid={testid || "copy-link-btn"}
      type="button"
      onClick={doCopy}
      title={`Скопировать ссылку: ${url}`}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: compact ? "4px 8px" : "7px 12px",
        borderRadius: 6,
        border: "1px solid " + (copied ? "#16a34a" : "#e5e7eb"),
        background: copied ? "#f0fdf4" : "white",
        color: copied ? "#14532d" : "#374151",
        fontFamily: "Manrope",
        fontSize: compact ? 11 : 12,
        fontWeight: 600,
        cursor: "pointer",
        transition: "all .15s",
      }}
    >
      {copied ? <Check size={compact ? 12 : 14} /> : <Copy size={compact ? 12 : 14} />}
      {copied ? copiedLabel : label}
    </button>
  );
}
